/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Display_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Display Name" |
*
* @param {Edit_Event_Group_Display_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_display_name_label = /** @type {((inputs?: Edit_Event_Group_Display_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Display_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom d'affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigename")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome da visualizzare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображаемое имя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre para mostrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रदर्शित होने वाला नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome de exibição")
	return /** @type {LocalizedString} */ ("Display Name")
});